import { Maps } from 'js/components/Maps/index.js';

export class LocationMap extends Maps.GoogleMapsFree {
  static initClass() {
    Maps.FactoryForProvider['Google-Free'] = (data) => new this(data);
  }

  constructor(args) {
    super(args);
    this.pinWidth = 32;
    this.pinHeight = 42;
    this.BUFFER = 0;
  }
  svgPin(label, backgroundColor, textColor) {
    return `
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="32" height="42" viewBox="0 0 32 42">
          <g fill="none" fill-rule="evenodd">
              <path fill="#15284B" d="M0 16c0 11.44 16 26 16 26s16-14.56 16-26c0-8.58-7.086-16-16-16S0 7.42 0 16z"/>
              <circle cx="16" cy="16" r="8" fill="#FFF"/>
          </g>
      </svg>
    `;
  }
}

LocationMap.initClass();
